"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toArray"));

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.search");

function getQuery(name, search) {
  if (search === void 0) {
    search = typeof window !== 'undefined' && window.location && window.location.search.substr(1);
  }

  var queries = {};
  search && search.split('&').forEach(function (c) {
    if (c === '') {
      return;
    }

    var _c$split = c.split('='),
        _c$split2 = (0, _toArray2.default)(_c$split),
        key = _c$split2[0],
        values = _c$split2.slice(1);

    queries[decodeURIComponent(key)] = decodeURIComponent(values.join('='));
  });
  return name ? queries[name] : queries;
}

getQuery.default = getQuery;
var _default = getQuery;
exports.default = _default;
module.exports = exports["default"];